export default class PersonneFormWidgetEssaisPlanifiesController {
    /* @ngInject */
    constructor() {}

    $onInit() {}

    $onDestroy() {}
}
